export const TOOLTIP_TEXT = t => ({
  early_access: t('tooltip.early_access_limited_pool'),
  buy_back: t('tooltip.buy_back'),
});
